define('shared/lib/Error',[],function(){
    var g = this;
    var tester = new Error();
    var hasNativeSupport = tester.stack != null;
    var NativeError;
    var MAX_STACK = 50;

    if ( hasNativeSupport == false ) {
        NativeError = g.Error;
        MyError = function (msg){
            var callee;
            var i = 0;

            if ( this instanceof MyError ) {
                ret = new NativeError(msg);
            }
            else {
                ret = NativeError.apply(this, arguments);
            }

            ret.stack = "Error\n";

            try {
                callee = arguments.callee;

                while( (callee = callee.caller) && i < MAX_STACK ) {
                    ret.stack += '     at ' + callee.toString() + '\n';
                    i++;
                }
            }
            catch(ex) {}

            return ret;
        };
        g.Error = MyError;
    }

    return {
        isNative: hasNativeSupport
    };
});
